export const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
    ]
}